import {
  EditFRDMeasurementConfigTask,
  EditFRDMeasurementTask,
  EditFRDStartRegistrationTask,
  FRDClosureTask,
  FRDMeasurementConfigTask,
  FRDMeasurementTask,
  FRDStartRegistrationTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createFrdUiSchemaLibrary } from "./frd-ui-schema-library";

/**
 * Unified UI Schema hook for all FRD forms.
 * Returns a shared ui-schema covering all four FRD form types (start-registration,
 * measurement-config, measurement, closure).
 */
export function useFrdUiSchema(
  qualityRegime: QualityRegimeOptions | undefined
): BrostarUiSchema<
  | FRDStartRegistrationTask
  | EditFRDStartRegistrationTask
  | FRDMeasurementConfigTask
  | EditFRDMeasurementConfigTask
  | FRDMeasurementTask
  | EditFRDMeasurementTask
  | FRDClosureTask
> {
  const lib = createFrdUiSchemaLibrary(qualityRegime);

  return {
    "ui:order": ["metadata", "sourcedocumentData", "measurementConfigFile", "measurementFile"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber: lib.projectNumber,
      broId: lib.broId,
      qualityRegime: lib.qualityRegime,
      deliveryAccountableParty: lib.deliveryAccountableParty,
      correctionReason: lib.correctionReason,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      // Start Registration fields
      objectIdAccountableParty: lib.objectIdAccountableParty,
      gmwBroId: lib.gmwBroId,
      tubeNumber: lib.tubeNumber,
      groundwaterMonitoringNets: lib.groundwaterMonitoringNets,

      // Measurement fields
      measurementDate: lib.measurementDate,
      measurementOperatorKvk: lib.measurementOperatorKvk,
      determinationProcedure: lib.determinationProcedure,
      evaluationProcedure: lib.evaluationProcedure,
      relatedCalculatedApparentFormationResistance: {
        calculationOperatorKvk: { "ui:widget": "OrganisationSelect" },
        evaluationProcedure: lib.evaluationProcedure,
      },
    },
    measurementConfigFile: lib.measurementConfigFile,
    measurementFile: lib.measurementFile,
  };
}
